import RetargetingListForm from 'common/pages/retargeting-list/RetargetingListForm'

export const RetargetingListFormAgency = (props) => <RetargetingListForm {...props} />
